module.exports = __webpack_public_path__ + "static/media/top-img_5@2x.9ca2d99b.png";